import React from "react";
import { TextField } from "@mui/material";

const CustomTextInput = (props) => {
  const {
    label,
    value,
    onChange,
    name,
    error,
    helperText,
    disabled,
    isLock,
    isReadOnly,
    isLabel = false,
    ...rest
  } = props

  return (
    <TextField
      fullWidth
      variant="outlined"
      name={name}
      label={isLock ? "Lock" : isLabel ? label : null}
      value={value}
      onChange={onChange}
      error={!!error}
      helperText={helperText}
      disabled={isLock || disabled}
      InputProps={{
        readOnly: isReadOnly
      }}
      sx={{
        width: '100%',
      }}
      {...rest}
    />
  );
};

export default CustomTextInput;
